export const NAME = 'dialog';
